import { ContentStatus, ContentType } from "./contentCardTypes";
import { sanitizeTestId } from "../../../utils/string";

// Sanitizes id the same way LessonCard's safeId does, so a missing/unsafe id
// can't produce a colliding or malformed data-testid (e.g. "content-card-undefined").
export const buildContentCardTestId = (id: string | undefined): string => {
  const safeId = id != null ? sanitizeTestId(id) : "";
  return `content-card-${safeId || "unknown"}`;
};

export const buildLessonButtonText = (type: ContentType, status: ContentStatus): string => {
  let buttonText = "";

  switch (status) {
    case "inProgress":
      buttonText = "Continue ";
      break;
    case "completed":
      buttonText = "Retake ";
      break;
    case "notStarted":
    default:
      buttonText = "Start ";
  }

  switch (type) {
    case "video":
    case "breakfix":
      buttonText += "Lesson";
      break;
    case "codingChallenge":
      buttonText += " Challenge";
      break;
    case "path":
      buttonText += "Path";
      break;
    case "exercise":
      buttonText += "Exercise";
      break;
    default:
      buttonText += "Content"; // Fallback for unknown types (should not happen)
  }

  return buttonText;
};

const lessonTypeToBadgeFileName = (type: ContentType | string): string => {
  switch (type) {
    case "video":
    case "breakfix":
    case "codingChallenge":
    case "path":
    case "exercise":
      return type;
    case "hacking_challenge":
    case "ctf":
      return "ctfChallenge";
    case "app_lab":
    case "appLab":
      return "appLab";
    default:
      return "video"; // Fallback for unknown types
  }
};

export const getLessonBadgeSvg = (
  type: ContentType | undefined,
  status: ContentStatus
): string | null => {
  if (!type) return null;
  const badgeFolder = status === "completed" ? "complete" : "incomplete";

  const correctType = lessonTypeToBadgeFileName(type);

  try {
    return new URL(`../../../assets/badges/${badgeFolder}/${correctType}.svg`, import.meta.url)
      .href;
  } catch {
    return null;
  }
};
